import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const Installmentpayment  = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Installment payment";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
